module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react","umd":"react"}
// module id = 0
// module chunks = 0